import React from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import SelectedAccountChip from '@/pages/company/BankFeedRoute/components/FilterToolbar/shared/SelectedAccountChip';

// Collapsed trigger for a multi-select toolbar filter: the first selection as a Chip + a "+N"
// counter whose tooltip lists every selection, one per line. Shared by the Bank account filter
// (DA-19179) and the Credit Card payment-date filter (DPM-666), which render an identical trigger
// even though their selection semantics differ (Select All, search-scoped commit, whether an empty
// selection is legal). Only the trigger is shared, deliberately — a shared *control* would need a
// flag per difference, and each flag is a place where changing one filter silently changes the
// other. Typed on the { id, label } shape both option types already satisfy.
type Selectable = { id: string; label: string };

const SelectedChips: React.FC<{ picked: Selectable[] }> = ({ picked }) => {
  const [first, ...rest] = picked;
  if (!first) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'nowrap', minWidth: 0 }}>
      <SelectedAccountChip label={first.label} />
      {rest.length > 0 && (
        <Tooltip
          placement="bottom-start"
          title={
            <Box>
              {picked.map((p) => (
                <Box key={p.id} sx={{ typography: 'caption', py: 0.25 }}>
                  {p.label}
                </Box>
              ))}
            </Box>
          }
        >
          <Chip label={`+${rest.length}`} size="small" />
        </Tooltip>
      )}
    </Box>
  );
};

export default SelectedChips;
